import { Component, inject } from '@angular/core';
import { Upload } from 'app/core/models/upload.model';
import { OutboundFaxImportsService } from 'app/core/services/outbound-fax-imports.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-capture-admin-import-outbound-faxes',
    templateUrl: './capture-admin-import-outbound-faxes.component.html',
    styleUrls: ['./capture-admin-import-outbound-faxes.component.scss'],
    imports: [ImportNavComponent, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportOutboundFaxesComponent {
  private outboundFaxImportsService = inject(OutboundFaxImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = {};
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.outboundFaxImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/communications/import-outbound-faxes/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
